<p aria-live="polite" class="sr-only" role="status">{{ announcement() }}</p>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayGrowAfterOpen]="true"
    [cdkConnectedOverlayOpen]="isOpen()"
    [cdkConnectedOverlayOrigin]="origin()"
    [cdkConnectedOverlayPositions]="positions"
    [cdkConnectedOverlayPush]="true"
    (detach)="closing.emit('detach')"
    (overlayKeydown)="onOverlayKeydown($event)"
>
    <div
        animate.enter="animate-scale-in"
        animate.leave="animate-scale-out"
        class="coach-mark flex w-375 origin-top-right flex-col gap-y-12 rounded-24 p-16 shadow zoom-from-80 motion-reduce:animate-none"
    >
        <div class="flex items-center gap-x-8">
            <interacta-image [alt]="''" [classes]="'h-24'" [src]="brandSrc()" />
            <button
                class="ml-auto"
                interacta-icon-button
                type="button"
                [icon]="'close'"
                [label]="'UI.BUTTON.CLOSE' | translate"
                [size]="'small'"
                [style]="'text'"
                (click)="closing.emit('button')"
            ></button>
        </div>

        <div class="flex flex-col" [id]="descriptionId">
            <p class="typo-medium-bold">
                {{ 'AI.DISCOVERY.COACH_MARK_GREETING' | translate }}
            </p>
            <p class="typo-medium">
                {{ 'AI.DISCOVERY.COACH_MARK_DESCRIPTION' | translate }}
            </p>
        </div>

        <button
            class="self-end"
            interacta-button
            type="button"
            [icon]="'play-filled'"
            [label]="'AI.DISCOVERY.WATCH_NOW' | translate"
            [size]="'small'"
            [style]="'filled'"
            (click)="watchNow.emit()"
        ></button>
    </div>
</ng-template>
